import React, { useContext } from 'react';
import posthog from 'posthog-js';
import { useFeatureFlagEnabled } from 'posthog-js/react';
import FirebaseContext from '../../../context/FirebaseContext';
import UserContext from '../../../context/UserContext';
import useSessionStore from '../../../hooks/useSessionStore';
import useToolsNavigation from '../../hooks/useToolsNavigation';
import ClientQuickInfoButton from '../../components/ClientQuickInfoButton';
import AddClientTaskButton from '../../components/AddClientTaskButton';
import useLogger from '../../../hooks/useLogger';
import PodContext from '../../../context/PodContext';
import { FeatureFlag, useM2VoiceNotePilotEnabled } from '../../../utils/postHog';
import WebMediaRecorder from './WebMediaRecorder';

const withChatProps = (Component) => (props) => {
  const { firebase } = useContext(FirebaseContext);
  const { userId: chatUserId } = useContext(UserContext);
  const { selectedPodId } = useContext(PodContext);
  const sessionStore = useSessionStore();
  const { navigateToClientPage } = useToolsNavigation();
  const webMediaRecorder = new WebMediaRecorder();
  const { logEvent } = useLogger();
  const isSmartContextEnabled = useFeatureFlagEnabled(FeatureFlag.ENABLE_SMART_CONTEXT);
  const isVoiceNotePilotCoach = useM2VoiceNotePilotEnabled(chatUserId);

  const renderHeaderExtras = (clientId) => (
    <>
      <ClientQuickInfoButton userId={clientId} />
      <AddClientTaskButton clientId={clientId} coachId={chatUserId} pill />
    </>
  );

  const chatProps = {
    firebase,
    posthog,
    sessionStore,
    chatUserId,
    selectedPodId: selectedPodId ?? '',
    mediaRecorder: webMediaRecorder,
    navigateToClientPage,
    renderHeaderExtras,
    logEvent,
    parentApp: 'web',
    isSmartContextEnabled,
    isVoiceNotePilotCoach,
  };

  return <Component {...props} chatProps={chatProps} />;
};

export default withChatProps;
